
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { CustomTitleService } from 'src/app/core/custom-title/custom-title.service';
import { Partner } from 'src/app/config/partner/_default';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: true,
    imports: [RouterLink, TranslatePipe]
})
export class NotFoundComponent {

  readonly partner = Partner.id;

  constructor(
    private title: CustomTitleService
  ) {
    this.title.setTitle('error.page.not-found.title', true);
  }

}
